// Declare functions using function declarations instead of const arrow functions.
// This allows safe redeclaration when loaded multiple times via jQuery.load()

function checkboxValidation(checkbox, index) {
  if (
    !checkbox ||
    !checkbox.parentNode ||
    !checkbox.ownerDocument ||
    checkbox.ownerDocument !== document
  ) {
    console.warn(`Checkbox ${index} is not valid or in DOM, skipping initialization`);
    return false;
  }

  return true;
}

function uncheckIfExists(ids) {
  ids.forEach((id) => {
    const el = document.getElementById(id);
    if (el) {
      el.checked = false;
    }
  });
}

function hideIfExists(ids) {
  ids.forEach((id) => {
    const el = document.getElementById(id);
    if (el) {
      el.style.display = 'none';
    }
  });
}

function clearInlineStyleIfExists(ids) {
  ids.forEach((id) => {
    const el = document.getElementById(id);
    if (el) {
      el.style.display = '';
    }
  });
}

// Manually add active class to select and date inputs to mimic floating label behavior
// since MDB's select doesn't support floating labels and our datepicker is a custom implementation.
function hasFloatingLabelValue(inputElement) {
  const $el = $(inputElement);

  if ($el.is('[readonly]')) {
    return true;
  }

  const value = ($el.val() || '').trim();

  if (value) {
    return true;
  }

  if (typeof $el.inputmask === 'function') {
    try {
      const unmasked = $el.inputmask('unmaskedvalue');
      return unmasked?.length > 0;
    } catch {
      // inputmask not initialized
    }
  }

  return false;
}

function mimicMaterialFloatingLabel(inputElement) {
  const $el = $(inputElement);

  if ($el.is('select')) {
    $el.addClass('active');
    return;
  }

  if (!hasFloatingLabelValue(inputElement)) {
    $el.removeClass('active valid');
    return;
  }

  $el
    .addClass('active')
    .toggleClass('valid', !$el.hasClass('error'));
}

function attachFloatingLabelListeners(input) {
  mimicMaterialFloatingLabel(input);

  if (input.hasAttribute('data-mdb-listeners-attached')) {
    return;
  }

  input.setAttribute('data-mdb-listeners-attached', 'true');

  ['blur', 'change', 'input'].forEach((eventName) => {
    input.addEventListener(eventName, () => {
      mimicMaterialFloatingLabel(input);
    });
  });
}

function initializeMDBPopovers() {
  if (typeof mdb === 'undefined' || !mdb.Popover) {
    return;
  }

  document
    .querySelectorAll('[data-mdb-toggle="popover"]')
    .forEach((element) => new mdb.Popover(element));

  document
    .querySelectorAll('.popover-dismiss')
    .forEach((element) => new mdb.Popover(element, { trigger: 'focus' }));
}

function initializeMDBComponentsForCheckboxes() {
  if (typeof mdb === 'undefined' || !mdb.Input) {
    return;
  }

  try {
    const newToggleCheckboxes = document.querySelectorAll(
      '.togglebutton.checkbox input[type="checkbox"]:not([data-mdb-input-initialized])',
    );

    newToggleCheckboxes.forEach((checkbox, index) => {
      try {
        if (!checkboxValidation(checkbox, index)) {
          return;
        }

        const wrapper = checkbox.closest('.togglebutton.checkbox');

        if (!wrapper) {
          return;
        }

        wrapper.classList.add('form-check');
        checkbox.classList.add('form-check-input');

        wrapper
          .querySelector('label')
          ?.classList.add('form-check-label');

        checkbox.setAttribute('data-mdb-input-initialized', 'true');
      } catch (err) {
        console.error(
          `Failed to initialize MDB Input for togglebutton checkbox ${index}:`,
          err.message,
        );
      }
    });

    const newCheckboxes = document.querySelectorAll(
      '.checkbox input[type="checkbox"]:not([data-mdb-input-initialized]):not(.togglebutton input[type="checkbox"])',
    );

    newCheckboxes.forEach((checkbox, index) => {
      try {
        if (!checkboxValidation(checkbox, index)) {
          return;
        }

        checkbox.classList.add('form-check-input');

        checkbox.parentElement
          ?.querySelector('label')
          ?.classList.add('form-check-label');

        checkbox
          .closest('.checkbox')
          ?.classList.add('form-check');
      } catch (err) {
        console.error(
          `Failed to initialize MDB Input for checkbox ${index}:`,
          err.message,
        );
      }
    });
  } catch (err) {
    console.error('Error initializing MDB components for checkboxes:', err);
  }
}

function initializeSelects() {
  document.querySelectorAll('.form-select').forEach((select) => {
    attachFloatingLabelListeners(select);
  });
}

function initializeDatePickers() {
  document.querySelectorAll('.datePickerBasic').forEach((input) => {
    attachFloatingLabelListeners(input);
  });

  document.querySelectorAll('.form-outline').forEach((inputFormGroup) => {
    const label = inputFormGroup.querySelector('.form-label');

    if (!label) {
      return;
    }

    const elementCount =
      (label.innerHTML.match(/<br\s*\/?>|<p\b[^>]*>/gi) || []).length;

    if (elementCount === 0) {
      return;
    }

    const translateY = -1.5 - elementCount;
    label.style.transform = `translateY(${translateY}rem)`;
  });
}

function initializeMDBComponentsForInputs() {
  if (typeof mdb === 'undefined' || !mdb.Input) {
    return;
  }

  const processedOutlines = new Set();

  document
    .querySelectorAll(
      '.form-outline input.form-control, .form-outline textarea.form-control',
    )
    .forEach((input) => {
      if (['checkbox', 'radio'].includes(input.type)) {
        return;
      }

      const inputFormGroup = input.closest('.form-outline');

      if (!inputFormGroup || processedOutlines.has(inputFormGroup)) {
        return;
      }

      processedOutlines.add(inputFormGroup);

      let instance = mdb.Input.getInstance(inputFormGroup);

      if (!instance) {
        instance = new mdb.Input(inputFormGroup);
        instance.init();
      }

      instance.update();

      attachFloatingLabelListeners(input);
    });
}

function initializeMDBComponentsForAll() {
  initializeMDBPopovers();
  initializeMDBComponentsForCheckboxes();
  initializeSelects();
  initializeDatePickers();
  initializeMDBComponentsForInputs();
}
